import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

import { environment } from '@app/environment';
import { LoggedUserService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
    
    constructor(
        private loggedUserService: LoggedUserService,
    ) { }
    
    buildLogaToken(): string {
        let ciphertext: string = '';
        let loggedUser = this.loggedUserService.loggedUser;
        if(loggedUser){
            let text = loggedUser.login + "|" + this.loggedUserService.jwtToken + "|" + new Date().getTime();
            let keyHex = CryptoJS.enc.Utf8.parse(environment.KEY_EXTERNAL_TOKEN);
            ciphertext = CryptoJS.AES.encrypt(text, keyHex, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString();                                             
            // make it base64 compliant with Apache Commons URLSafe
            ciphertext = ciphertext.replace(/\//g, '_').replace(/\+/g, '-').replace(/\=+$/, '');
        }
        return ciphertext;
    }
        
    buildAnimaToken(logaWorkDayId: number | undefined, lastModified?: number): string {        
        let ciphertext: string = '';
        if (logaWorkDayId) {     
            let time = lastModified != undefined ? lastModified : new Date().getTime();
            let text = 'CL' + '|' + logaWorkDayId + '|' + time + '|locupa';
            let keyHex = CryptoJS.enc.Utf8.parse(environment.KEY_EXTERNAL_TOKEN);            
            ciphertext = CryptoJS.AES.encrypt(text, keyHex, {
              mode: CryptoJS.mode.ECB,
              padding: CryptoJS.pad.Pkcs7
            }).toString();                      
            // make it base64 compliant with Apache Commons URLSafe
            ciphertext = ciphertext.replace(/\//g, '_').replace(/\+/g, '-').replace(/\=+$/, '');
        }   
        return ciphertext;
    }
    
}
